import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiPost } from '../api/client';
import { useAuth } from '../auth/AuthProvider';
import styles from './LoginPage.module.css';

export default function LoginPage() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const year = new Date().getFullYear();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = (await apiPost('/api/auth/login', { email, password })) as {
        user?: { id: string; email: string; role: 'admin' | 'sales' | 'viewer'; name: string };
      };
      if (data?.user) {
        setUser(data.user);
        navigate('/operate');
      } else {
        setError('Error al iniciar sesión');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error de conexión. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  const stamp = new Date().toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  return (
    <div className={styles.loginEditorial}>
      <a className={styles.loginBrand} href="/">
        <span className={styles.loginBrandKicker}>Grande&amp;Gordo</span>
        <span className={styles.loginBrandTitle}>Gordoleads</span>
      </a>

      <main className={styles.loginStage}>
        <section className={styles.loginMasthead}>
          <p className={styles.loginKicker}>Edici&oacute;n privada</p>
          <h1 className={styles.loginHead}>Tu bit&aacute;cora.</h1>
          <p className={styles.loginDeck}>
            Sistema interno de Gordoleads; acceso restringido al equipo de Grande&amp;Gordo.
          </p>
          <p className={styles.loginStamp}>N.&nbsp;{stamp}</p>
        </section>

        <div className={styles.loginDivider} aria-hidden="true" />

        <section className={styles.loginFormWrap}>
          <form className={styles.loginForm} onSubmit={handleSubmit}>
            {error && <div className={styles.loginError}>{error}</div>}
            <div className={styles.loginField}>
              <label htmlFor="email">Correo electr&oacute;nico</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="tu@email.com"
                required
                autoComplete="email"
                // autoFocus removed for a11y
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className={styles.loginField}>
              <label htmlFor="password">Contrase&ntilde;a</label>
              <input
                type="password"
                id="password"
                name="password"
                required
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button type="submit" className={styles.loginSubmit} disabled={loading}>
              {loading ? 'Entrando…' : 'Entrar'}
            </button>
          </form>
        </section>
      </main>

      <footer className={styles.loginFootnote}>
        <span>
          <strong>Gordoleads</strong>, herramienta interna
        </span>
        <span>Grande&amp;Gordo, {year ?? ''}</span>
      </footer>
    </div>
  );
}
